import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/img/product_logo_color.png'


const _hoisted_1 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, " ", -1)
const _hoisted_3 = {
  class: "flex justify-center align-center mr-10",
  id: "footerLinks"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "productLogo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)

import { useGlobalStore } from '@/stores/GlobalStore';
import {computed} from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const globalStore = useGlobalStore()
const isQA = computed(()=> window.location.origin.includes('-qa.'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "footer",
    class: "flex",
    style: _normalizeStyle([isQA.value?'background-color: yellow;':''])
  }, [
    (isQA.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "QA"))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "flex",
        href: _unref(globalStore).settings.systemConfig?.imprintLink
      }, _toDisplayString(_ctx.$t('footer.imprint')), 9, _hoisted_4),
      _createElementVNode("a", {
        class: "flex",
        href: _unref(globalStore).settings.systemConfig?.privacyLink
      }, _toDisplayString(_ctx.$t('footer.privacy')), 9, _hoisted_5),
      _createElementVNode("a", {
        class: "flex",
        href: _unref(globalStore).settings.systemConfig?.disclaimerLink
      }, _toDisplayString(_ctx.$t("footer.disclaimer")), 9, _hoisted_6)
    ]),
    _hoisted_7
  ], 4))
}
}

})